import { Accordion, AccordionSummary, Checkbox, Radio } from "@mui/material";
import React, { useMemo } from "react";
import styles from "./ExpandableRow.module.css";
import { CustomTooltip } from "../../../../../../common/components";

const ExpandableRow = ({ item, indentLevel = 0, isMultipleChoice = false, onCheck, onIsChecked, readOnly }) => {
	const isChecked = useMemo(() => onIsChecked(item), [onIsChecked, item]);
	const handleCheck = () => {
		onCheck(item, isChecked);
	};
	return (
		<Accordion
			expanded
			classes={{
				root: styles.accordion__root,
			}}
			style={{
				marginLeft: indentLevel > 0 ? 32 : 0,
			}}
		>
			<AccordionSummary
				classes={{
					root: styles.accordionSummary__root,
					content: styles.accordionSummary__content,
				}}
				style={{
					cursor: "default",
				}}
			>
				{(isMultipleChoice && (
					<Checkbox
						checked={isChecked}
						className={styles.checkBox}
						disabled={readOnly}
						size="small"
						onChange={handleCheck}
					/>
				)) || <Radio checked={isChecked} disabled={readOnly} size="small" onChange={handleCheck} />}
				<CustomTooltip showWhenOverflow title={item.value}>
					<span className={styles.categoryName}>{item.value}</span>
				</CustomTooltip>
			</AccordionSummary>
		</Accordion>
	);
};

export default ExpandableRow;
